import React from 'react'

const LogsIcon = (
  <>
    <path
      d="M0.916687 11.5H21.0834"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.916687 5.08331H21.0834"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.916687 17.9166H11"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export default LogsIcon
